export const showAsFree = "F6PxPd";
export default {showAsFree};